export default function getNameInitials(name: string | null | undefined) {
  if (typeof name !== 'string') {
    return '';
  }
  const words = (name || '')
    .toLocaleUpperCase()
    .replace(/[.\d]/g, '')
    .split(/\s+/)
    .filter((w) => w.length > 0);

  if (words.length === 0) {
    return '';
  }
  if (words.length === 1) {
    return words[0].slice(0, 2).toLocaleUpperCase();
  }
  return words
    .map((w) => w.slice(0, 1))
    .join('')
    .slice(0, 2);
}
